// // 愛媛
// export const DEFAULT_POSITION = {
//   LAT: 33.506399,
//   LNG: 132.544520,
// }

// 大分
export const DEFAULT_POSITION = {
  LAT: 33.2305526,
  LNG: 131.6068285,
}

export const DEFAULT_MAP_ZOOM = 10

// 地図に表示するベクタータイルのリスト
// 1つめは必ず解析雨量レーダーとすること
export const BASE_LAYER_LIST = [
	{
		category: 'h1_msh',
		name: '1時間雨量',
		maxZoomSize: 12,
		is_river: false,
        unit: 'mm/h',
        ticks: [20, 30, 50, 80],
        domains: [0, 80],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: true
	},
	{
		category: 'h24_msh',
		name: '24時間雨量',
		maxZoomSize: 12,
		is_river: false,
		unit: 'mm',
        ticks: [150, 200, 250, 300],
        domains: [0, 300],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: true
	},
	{
		category: 'h48_msh',
		name: '48時間雨量',
		maxZoomSize: 12,
		is_river: false,
		unit: 'mm',
        ticks: [200, 250, 300, 400],
        domains: [0, 400],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: true
	},
	{
		category: 'sr_msh',
		name: '土壌雨量指数',
		maxZoomSize: 12,
		is_river: false,
		unit: '',
        ticks: [80, 120, 150, 200],
        domains: [0, 200],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: false
	},
	{
		category: 'rsk_msh',
		name: '土砂災害発生リスク',
		maxZoomSize: 12,
		is_river: false,
		unit: '',
        ticks: [300, 600, 1000, 2000],
        tickLabel: ['レベル1', 'レベル2', 'レベル3', 'レベル4'],
        domains: [0, 200],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: false
	},
	// {
	//   category: 'rfs_msh',
	//   name: '河川洪水発生リスク',
	//   maxZoomSize: 12,
	//   is_river: false,
	// },
	{
		category: 'h1_bsn',
		name: '流域平均1時間雨量',
		maxZoomSize: 12,
		is_river: true,
		unit: 'mm/h',
        ticks: [20, 30, 50, 80],
        domains: [0, 80],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: true
	},
	{
		category: 'h24_bsn',
		name: '流域平均24時間雨量',
		maxZoomSize: 12,
		is_river: true,
		unit: 'mm',
        ticks: [150, 200, 250, 300],
        domains: [0, 300],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: true
	},
	{
		category: 'h48_bsn',
		name: '流域平均48時間雨量',
		maxZoomSize: 12,
		is_river: true,
		unit: 'mm',
        ticks: [200, 250, 300, 400],
        domains: [0, 400],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: true
	},
	{
		category: 'of_bsn',
		name: '流域平均流出量',
		maxZoomSize: 12,
		is_river: true,
		unit: '',
        ticks: [2, 5, 8, 15],
        domains: [0, 15],
        xaxisKeyList: ['date'],
        dataKey: 'value',
        isUnit: false
	},
]

